import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

/**
 * Date field for schedule forms using react-hook-form
 *
 * @param control: react-hook-form control object
 */

interface IProps {
  name: string;
  control: any;
  label: string;
  style?: any;
  readOnly?: boolean;
}

const FormDateField = (props: IProps) => {
  const { style, name, control, label, readOnly } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={value ?? ""}
          data-testid={name}
          fullWidth
          label={label}
          variant="outlined"
          sx={style}
          type="date"
          inputProps={{ readOnly: readOnly || false }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default FormDateField;
